<div class="flex items-center">
  <div class="flex items-center space-x-2 z-10">
    <ng-container
      *ngTemplateOutlet="
        mode === 'range'
          ? rangeModeTemplate
          : mode === 'range_optional'
          ? stateVisibleMode
            ? rangeModeTemplate
            : durationModeTemplate
          : mode === 'duration'
          ? durationModeTemplate
          : null
      "
    ></ng-container>
    <div
      class="rounded-lg px-2.5 h-12 flex items-center flex-shrink-0 cursor-default"
      tabindex="0"
      [class.mat-bg]="!showMenu?.value"
    >
      <div class="flex flex-col flex-1">
        <ng-container *ngIf="controlValue$.value$ | async as value">
          <div
            class="leading-none font-semibold text-center"
            *ngIf="!mode || mode === 'range' || (mode === 'range_optional' && stateVisibleMode)"
          >
            {{ (mode !== 'duration' ? value.rangeDuration : value.duration) ?? 0 | parseMsAsDuration: false }}
          </div>
          <div class="leading-none mat-hint mt-0.5" *ngIf="value?.date as date">{{ date | formatDate }}</div>
        </ng-container>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="mode === 'range_optional' ? modeToggle : null"></ng-container>
  </div>
  <div
    class="absolute mbg-card top-0 inset-x-0 rounded-lg -mx-1.5 -mt-1.5"
    @matScale
    *ngIf="showMenu?.value"
    tabindex="-1"
  >
    <div class="h-16"></div>
    <mat-divider></mat-divider>
    <div class="flex-1 flex flex-col" tabindex="-1">
      <mat-calendar
        class="-mt-4"
        tabindex="-1"
        [selected]="controlValue.date"
        [startAt]="controlValue.date"
        [dateFilter]="availableDates"
        (selectedChange)="updateDate($event)"
        color="primary"
      ></mat-calendar>
    </div>
    <div class="h-6"></div>
  </div>
</div>
<ng-template #noTimeValue>
  <div>00:00</div>
</ng-template>
<mat-menu #timeContextMenuTimeTemplates="matMenu">
  <ng-template matMenuContent let-data>
    <button mat-menu-item (click)="setMinutesDiff(5, data.prop)">
      {{ 'timeContextMenu.setTo.MinDiffs' | translate: { value: 5 } }}
    </button>
    <button mat-menu-item (click)="setMinutesDiff(10, data.prop)">
      {{ 'timeContextMenu.setTo.MinDiffs' | translate: { value: 10 } }}
    </button>
    <button mat-menu-item (click)="setMinutesDiff(15, data.prop)">
      {{ 'timeContextMenu.setTo.MinDiffs' | translate: { value: 15 } }}
    </button>
    <button mat-menu-item (click)="setMinutesDiff(30, data.prop)">
      {{ 'timeContextMenu.setTo.MinDiffs' | translate: { value: 30 } }}
    </button>
    <button mat-menu-item (click)="setHourDiff(1, data.prop)">
      {{ 'timeContextMenu.setTo.HrDiff' | translate: { value: 1 } }}
    </button>
    <button mat-menu-item (click)="setHourDiff(2, data.prop)">
      {{ 'timeContextMenu.setTo.HrDiffs' | translate: { value: 2 } }}
    </button>
    <button mat-menu-item (click)="setHourDiff(4, data.prop)">
      {{ 'timeContextMenu.setTo.HrDiffs' | translate: { value: 4 } }}
    </button>
    <button mat-menu-item (click)="setWorkDay()">{{ 'timeContextMenu.setTo.1workDay' | translate }}</button>
  </ng-template>
</mat-menu>
<mat-menu #timeContextMenu="matMenu">
  <ng-template matMenuContent let-data>
    <button mat-menu-item (click)="setToNow(data.prop)">{{ 'timeContextMenu.setTo.now' | translate }}</button>
    <button mat-menu-item [matMenuTriggerFor]="timeContextMenuTimeTemplates" [matMenuTriggerData]="{ $implicit: data }">
      {{ 'timeContextMenu.setToMore' | translate }}
    </button>
  </ng-template>
</mat-menu>
<div
  style="visibility: hidden; position: fixed"
  [style.left]="timeContextMenuPosition.x"
  [style.top]="timeContextMenuPosition.y"
  #timeContextMenuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="timeContextMenu"
></div>
<ng-template #startEndTemplate>
  <form
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="10px"
    (submit)="$event.preventDefault()"
    [formGroup]="control"
    #timespanRef
  >
    <div fxFlex="86px" class="pb-0">
      <app-time-input formControlName="start" [displayFormat]="false" placeholder="00:00">
        <ng-template
          timeInputControl
          let-control="control"
          let-placeholder="placeholder"
          let-inputPlaceholder="inputPlaceholder"
        >
          <mat-form-field
            fxFill
            [matTooltip]="inputPlaceholder | translate"
            appearance="fill"
            class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain text-center"
          >
            <input type="text" matInput [attr.placeholder]="placeholder" [formControl]="control" />
          </mat-form-field>
        </ng-template>
      </app-time-input>
    </div>
    <mat-icon inline>arrow_forward</mat-icon>
    <div fxFlex="86px" class="pb-0">
      <app-time-input formControlName="end" [displayFormat]="false" placeholder="00:00">
        <ng-template
          timeInputControl
          let-control="control"
          let-placeholder="placeholder"
          let-inputPlaceholder="inputPlaceholder"
        >
          <mat-form-field
            fxFill
            appearance="fill"
            [matTooltip]="inputPlaceholder | translate"
            class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain text-center"
          >
            <input type="text" matInput [attr.placeholder]="placeholder" [formControl]="control" />
          </mat-form-field>
        </ng-template>
      </app-time-input>
    </div>
  </form>
</ng-template>
<ng-template #rangeModeTemplate>
  <ng-container *ngTemplateOutlet="startEndTemplate"></ng-container>
</ng-template>
<ng-template #rangeOptModeTemplate>
  <ng-container *ngTemplateOutlet="startEndTemplate"></ng-container>
  <ng-container *ngTemplateOutlet="durationModeTemplate"></ng-container>
</ng-template>
<ng-template #durationModeTemplate>
  <form
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="10px"
    (submit)="$event.preventDefault()"
    [formGroup]="control"
    #timespanRef
  >
    <div fxFlex="86px" class="pb-0">
      <tg-duration-input-control
        formControlName="duration"
        displayFormat="HH:mm"
        placeholder="00:00"
        inputPlaceholder="timer.time.duration"
      >
        <ng-template
          durationInputControl
          let-control="control"
          let-placeholder="placeholder"
          let-inputPlaceholder="inputPlaceholder"
        >
          <mat-form-field
            fxFill
            appearance="fill"
            [matTooltip]="inputPlaceholder | translate"
            class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain text-center"
          >
            <input type="text" matInput [attr.placeholder]="placeholder" [formControl]="control" />
          </mat-form-field>
        </ng-template>
      </tg-duration-input-control>
    </div>
  </form>
</ng-template>
<ng-template #modeToggle>
  <button mat-icon-button [matTooltip]="'timer.time.changeInputMode' | translate" (click)="toggleStateVisibleMode()">
    <mat-icon>swap_horiz</mat-icon>
  </button>
</ng-template>
